// src/components/buyerPersona/QuestionCard.jsx
import React from 'react';
import { FaCheck, FaRegSquare, FaRegCheckSquare, FaRegCircle, FaRegDotCircle } from 'react-icons/fa';

const QuestionCard = ({ question, questionNumber, selectedAnswer, onAnswer }) => {
    const handleOptionClick = (optionText) => {
        if (question.type === 'multiple') {
            const currentAnswers = Array.isArray(selectedAnswer) ? selectedAnswer : [];
            const newAnswers = currentAnswers.includes(optionText)
                ? currentAnswers.filter(answer => answer !== optionText)
                : [...currentAnswers, optionText];
            onAnswer(question.question, newAnswers);
        } else {
            onAnswer(question.question, optionText);
        }
    };

    const isOptionSelected = (optionText) => {
        if (question.type === 'multiple') {
            return Array.isArray(selectedAnswer) && selectedAnswer.includes(optionText);
        } else {
            return selectedAnswer === optionText;
        }
    };

    return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
            {/* Question Header */}
            <div className="p-4 sm:p-6 border-b border-gray-100">
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0">
                        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 text-sm font-semibold">
                            {questionNumber}
                        </span>
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-base sm:text-lg font-medium text-gray-900 leading-relaxed">
                            {question.question}
                        </h3>
                        <div className="mt-2 flex items-center">
                            {question.type === 'multiple' ? (
                                <div className="flex items-center text-purple-600">
                                    <FaRegCheckSquare className="w-4 h-4 mr-2" />
                                    <span className="text-sm font-medium">Selección múltiple</span>
                                </div>
                            ) : (
                                <div className="flex items-center text-blue-600">
                                    <FaRegDotCircle className="w-4 h-4 mr-2" />
                                    <span className="text-sm font-medium">Selección única</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Options */}
            <div className="p-2 sm:p-4">
                <div className="space-y-2">
                    {question.options && question.options.map((option, index) => (
                        <button
                            key={index}
                            onClick={() => handleOptionClick(option.text)}
                            className={`w-full text-left p-3 sm:p-4 rounded-lg transition-all duration-200 group hover:bg-gray-50 ${isOptionSelected(option.text)
                                    ? question.type === 'multiple'
                                        ? 'bg-purple-50 border-2 border-purple-200'
                                        : 'bg-blue-50 border-2 border-blue-200'
                                    : 'border-2 border-gray-100'
                                }`}
                        >
                            <div className="flex items-center gap-3">
                                {question.type === 'multiple' ? (
                                    <div className={`flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center transition-colors ${isOptionSelected(option.text)
                                            ? 'bg-purple-500 border-purple-500 text-white'
                                            : 'border-gray-300 group-hover:border-purple-300'
                                        }`}>
                                        {isOptionSelected(option.text) && <FaCheck className="w-3 h-3" />}
                                    </div>
                                ) : (
                                    <div className={`flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${isOptionSelected(option.text)
                                            ? 'border-blue-500'
                                            : 'border-gray-300 group-hover:border-blue-300'
                                        }`}>
                                        {isOptionSelected(option.text) && (
                                            <div className="w-3 h-3 rounded-full bg-blue-500" />
                                        )}
                                    </div>
                                )}
                                <span className={`flex-1 text-sm sm:text-base font-medium ${isOptionSelected(option.text)
                                        ? question.type === 'multiple'
                                            ? 'text-purple-900'
                                            : 'text-blue-900'
                                        : 'text-gray-700 group-hover:text-gray-900'
                                    }`}>
                                    {option.text}
                                </span>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default QuestionCard; 